<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle1')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle1') }}</h1>
    <span class="mt-5">{{ $t('artText1') }}</span>
    <img
      :src="`${staticUrl}/images/DreamFlat-Innovative-Home-Design-Software.webp`"
      :alt="'altImageDefault'"
    />
    <span>{{ $t('artText2') }}</span>
    <h2 class="tarifs-block-title">{{ $t('artText3') }}</h2>
    <TarifsComponentOnlyEn />
    <img
      :src="`${staticUrl}/images/DreamFlat-Innovative-Home-Design-Software1.webp`"
      :alt="'altImageDefault'"
    />
    <h2 class="mt-0">{{ $t('artText5') }}</h2>
    <span>{{ $t('artText6') }}</span>
    <ul>
      <li>{{ $t('artText6li1') }}</li>
      <li>{{ $t('artText6li2') }}</li>
      <li>{{ $t('artText6li3') }}</li>
      <li>{{ $t('artText6li4') }}</li>
    </ul>
    <h2>{{ $t('artText7') }}</h2>
    <span>{{ $t('artText8') }}</span>
    <img
      :src="`${staticUrl}/images/DreamFlat-Innovative-Home-Design-Software2.webp`"
      :alt="'altImageDefault'"
    />
    <span>{{ $t('artText9') }}</span>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle1')}`,
  ogTitle: `${t('artSeoTitle1')}`,
  description: `${t('artSeoDesc1')}`,
  ogDescription: `${t('artSeoDesc1')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
